module.exports = "https://r.nearpod.com/assets/media/image/global_close-eccc9bdee4f11811d80cde4f11d98a05.svg";